import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@chakra-ui/react'
import { OrderAssetReason, OrderAssetState, RequestOrigin } from '@leid/api-assets'

import { LeidYellowButton } from 'components/ui/Buttons/Button'
import { utcNow } from 'utils/dates'

import { FlowDirection, ManyAssetsReminderStepData, SelectedAssetData } from '../models'

type Props = {
  data: ManyAssetsReminderStepData
  onStepSuccess: () => void
  setAssetChangeRequest: (request: SelectedAssetData) => void
}

const ManyAssetsReminderStep = (props: Props): JSX.Element => {
  const { data, onStepSuccess, setAssetChangeRequest } = props
  const { t } = useTranslation('common')

  const handleConfirm = () => {
    const assetChangeRequest: SelectedAssetData = {
      reason: OrderAssetReason.SELF_REPORTED,
      state: data.flowDirection === FlowDirection.PICKUP ? OrderAssetState.PICKEDUP : OrderAssetState.RETURNED,
      timestamp: utcNow(),
      orderId: data.orderId,
      orderItemId: data.orderItemId,
      assetId: undefined,
      locationId: data.locationId,
      sublocationId: undefined,
      origin: RequestOrigin.UNKNOWN,
      visualTag: '',
    }
    setAssetChangeRequest(assetChangeRequest)

    onStepSuccess()
  }

  return (
    <>
      <Text fontSize="md">
        {data.flowDirection === FlowDirection.PICKUP
          ? t('pickupManyAssets', { amount: data.amount })
          : t('returnManyAssets', { amount: data.amount })}
      </Text>

      <LeidYellowButton onClick={handleConfirm}>{t('confirm')}</LeidYellowButton>
    </>
  )
}

export default ManyAssetsReminderStep
